<template>
	<Modal
		v-model="localModal"
		class="modal"
	>
		<TnHeading
			type="h1"
			size="s"
			class="margin-bottom-s padding-top-s"
		>
			{{ props.heading }}
		</TnHeading>
		<RichText
			v-if="props.freeText"
			:text="props.freeText"
			class="margin-top-m"
		/>
	</Modal>
</template>

<script setup lang="ts">
const props = defineProps<{
	modal: boolean;
	heading: string;
	freeText: string;
}>();

const localModal = ref(props.modal);
const emit = defineEmits(["update:modal"]);

watch(localModal, (newValue) => {
	emit("update:modal", newValue);
});
</script>

<style lang="scss" scoped></style>
